import { FC, ImgHTMLAttributes } from 'react';
import link from './assets/images/ImageMap5GLink';

const ImageMap5G: FC<ImgHTMLAttributes<never>> = (props) => {
  return <img src={link} alt="Mapa 5G" {...props} />;
};

export default ImageMap5G;
